exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagnation-nav[data-v-3310a9e6] {\n  overflow-x: scroll;\n  margin-top: 15px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-top: 1px solid #E3E3E3;\n  border-bottom: 1px solid #E3E3E3;\n  height: 50px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.pagnation-nav[data-v-3310a9e6]::-webkit-scrollbar {\n  display: none;\n}\n.pagnation-button[data-v-3310a9e6] {\n  background-color: transparent;\n  font-size: 13px;\n  color: #353635;\n  border: none;\n  outline: none;\n  margin-left: 10px;\n  margin-right: 10px;\n  cursor: pointer;\n}\n.pagnation-button.active[data-v-3310a9e6] {\n  color: #7AC143;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3310a9e6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/standard/pagination/Pagination.vue
// module id = ICw5
// module chunks = 53